













































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { QInput } from 'quasar'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import api from 'src/assets/api/gql'
import StudentContactUpdate from 'src/graphql/student/StudentContactUpdate.gql'
import { Item, Student } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen
  }
})
export default class ItemCourseStudentButtonEdit extends Vue {
  loading = false
  error = false
  name = ''

  @Prop()
  readonly item!: Item

  @Prop()
  readonly student!: Student

  @Ref()
  readonly dialog!: DialogFullscreen

  @Ref()
  readonly input!: QInput

  @Watch('name')
  clear () {
    this.error = false
  }

  edit () {
    this.error = false
    this.name = this.student.contactName || ''
    this.dialog.show()
  }

  reset () {
    this.error = false
    this.name = this.student.contactName || ''
  }

  async saveName () {
    if (this.name !== this.student.contactName) {
      this.loading = true
      const { data: { studentSetContactName }, error } = await api.mutate({
        query: StudentContactUpdate,
        variables: {
          id: this.item.ownerPublicProfile?.personId,
          contactPersonId: this.student.publicProfile?.personId,
          name: this.name
        }
      })
      this.loading = false
      if (error) {
        this.error = true
      } else {
        this.error = false
        this.$emit('update', studentSetContactName?.string || '')
      }
      this.$nextTick(() => { this.input.focus() })
    }
  }
}
